import { Provider } from '@cloud-native/workflows-engine'
import { FieldSchema, WorkflowNodeParameter } from 'features/workflows/types'

export const schemaToOptions = (provider: Provider, input: WorkflowNodeParameter, schema: FieldSchema[]) => {
  return !input.dataType
    ? schema?.map((s) => s.name)
    : schema
        ?.filter(
          (s) =>
            input.dataType?.includes(s.type) ||
            (provider == 'databricksRest' && input.dataType?.includes('geometry') && s.type == 'binary')
        )
        .map((s) => s.name)
}
